import Vue from "vue";
import Vuex from "vuex";
import { data } from "@/services/data";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		ready: false,
		loading: true,
		loadingText: "Loading data...",
		songs: {},
		artists: {} 
	},
	mutations: {
		loaded (state) {
			state.ready = true;
			state.loading = false;
		},
		loadingText (state, text) {
			state.loadingText = text;
		},
		songs (state, songs) {
			state.songs = songs;
		},
		artists (state, artists) {
			state.artists = artists;
		},
		countries (state, countries) {
			state.countries = countries;
		}
	},
	actions: {
		async loadSongs (context) {

			let result = {};

			try {
				if (process.env.NODE_ENV == "production") {
					result = await data.fetchDataRemote();
				} else {
					result = await data.fetchData();
				}
			} catch (e) {
				console.error(e);
				result = await data.fetchData();
			}

			context.commit("loadingText", "Treating data");

			context.commit("songs", result.songs);
			context.commit("artists", result.artists);
			context.commit("countries", result.countries);
			context.commit("loaded");
		}
	}
});
